<template>
  <!-- <div class="comp-bg"> -->
    <!-- <div id="carouselExampleIndicators" class="carousel splash" data-ride="carousel"> -->

    <!-- <div class="container-sm"> -->
      <div id="synopsis">
        <img v-bind:src="imgUrl" class="w-100" />

     
       
      </div>
    <!-- </div> -->
   
  <!-- </div> -->
  <!-- </div> -->
</template>

<script>
export default {
  name: "competition",
  data() {
    return {
      imgUrl:''
    };
  },
  mounted: function() {
    console.log(this.$route.query.subject)
this.imgUrl = `/static/subject`+this.$route.query.subject+`.png`
    // var navDiv = document.getElementById("nav-1");
    // var mt = navDiv.offsetTop;
    // console.log(mt)
    // window.onscroll = function() {
    //   var t = document.documentElement.scrollTop || document.body.scrollTop;
    //   // console.log(t)
    //   if (t > mt) {
    //     navDiv.style.position = "fixed";
    //     navDiv.style.top = "0";
    //   } else {
    //     navDiv.style.position = "relative";
    //   }
    // };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/subject1.vue